module.exports = __webpack_public_path__ + "static/media/icon.6fc66712.png";